class App {
    constructor() {}

    init(_option, isInitial) {
        this.option = {
            apiUrl: '',
            selector: '#autoSuggest',
            service: '',
            alias: '',
            submitCallback: _q => console.log('query :', _q, '::: option.submitCallback 설정은 필수 입니다'),
            size: 10,
            useDelbtn: false,
            addParam: {},
            ..._option
        };

        this.parent = document.querySelector(this.option.selector);
        this.loadedKeyword = '';
        this.dataBaseKeyword = '';
        this.isValueFunctionText = '';
        this.apiUrl = this.setApiUrl();
        this.suggestWrap = this.parent?.querySelector("[data-name='suggest_wrap']");
        this.input = this.parent?.querySelector("[data-name='suggest_input']");
        this.submitBtn = this.parent?.querySelector("[data-name='suggest_submit']");
        this.deleteBtn = this.parent?.querySelector("[data-name='suggest_delete']");
        this.resultUL = this.parent?.querySelector("[data-name='suggest_scroll'] ul");

        if (this.suggestWrap) {
            this.suggestWrap.style.display = 'none';
        }

        if (this.deleteBtn) {
            this.deleteBtn.style.display = 'none';
        }

        isInitial = isInitial === undefined ? true : isInitial;
        isInitial && this.addEvents();
    }

    setApiUrl() {
        let url = '';
        if (!this.option.apiUrl) {
            let env = location.href.match(/(rc\.|rc\-)/i) ? location.href.match(/(rc\.|rc\-)/i)[1] : 'live';
            env = (/local\.|localhost\.|opdev\.|ui-static\.|file:/i.test(location.href)) ? 'sb' : env;
            env = (/\/\/sb\-|\/\/sb\./i.test(location.href)) ? 'sb' : env;
            const apiDomains = {
                'opdev': 'http://opdev-searchsuggest.plaync.com',
                'sb': 'https://sb-ncs-searchsuggest.plaync.com/',
                'rc.': 'https://rc-searchsuggest.plaync.com',
                'rc-': 'https://rc-searchsuggest.plaync.com',
                'live': 'https://searchsuggest.plaync.com'
            };

            url = `${apiDomains[env]}/suggest/${this.option.service}/v1.0/${this.option.alias}`;
        } else {
            url = this.option.apiUrl;
        }

        return url;
    }

    setInputValue(val) {
        if (this.input) {
            this.input.value = val;
        }
    }

    getIndex(el) {
        if (!el) return -1;

        let i = 0;
        while (el = el.previousElementSibling) {
            i++;
        }
        return i;
    }

    setDisplay(target, isForceDisplay) {
        if (target) {
            target.style.display = isForceDisplay ? 'block' : 'none';
        }
    }

    load(_newKeyword) {
        if (this.ajaxCall && this.ajaxCall.abort) this.ajaxCall.abort();

        this.loadedKeyword = _newKeyword;
        let queryName = this.option.queryName || 'query';
        let params = {
            [queryName]: this.loadedKeyword?.replace(/\s*/g, ''),
            page_size: this.option.size,
            ...this.option.addParam
        };

        fetch(`${this.apiUrl}?${new URLSearchParams(params)}`, {
                method: 'GET',
                credentials: 'include'
            })
            .then(res => res?.json())
            .then(res => this.drawList(res))
            .catch(e => console.log('::::::::::fail::::::::::', e));
    }

    addEvents() {
        const keyEventType = (window._device && window._device === 'ingame') ? 'keypress' : 'keydown';
        const activeKeyCode = [27, 13, 9, 40, 38];
        this.input?.addEventListener(keyEventType, (e) => {
            const keyCode = e.keyCode;

            if(!activeKeyCode?.includes(keyCode)) {
                return;
            }

            switch(keyCode) {
                case 27: // ESC
                    this.setInputValue(this.loadedKeyword);
                    this.suggestWrapToggle(false);
                    break;
                case 13: // Enter
                    this.submitGo();
                    break;
                case 9: // Tab
                    this.focusChange(!e.shiftKey ? 1 : -1);
                    break;
                case 40: // ↓
                    this.focusChange(1);
                    break;
                case 38: // ↑
                    this.focusChange(-1);
                    break;
            }

            e.preventDefault();
            return false;
        });

        this.input?.addEventListener('focusout', e => {
            setTimeout(() => this.suggestWrapToggle(false), 150);
            if(this.sto) {
                clearTimeout(this.sto);
                this.sto = null;
            }
        });


        const resultLi = this.resultUL?.querySelectorAll('li');
        this.input.addEventListener('focusin', e => {
            this.isValueFunctionText = '';
            if (!this.sto) this.realTimeInputCheck();
            if (resultLi?.length) this.suggestWrapToggle(true);
        });

        this.submitBtn?.addEventListener('click', e => this.submitGo());

        this.deleteBtn?.addEventListener('click', e => {
            this.loadedKeyword = '';
            this.setInputValue('');
            this.input?.focus();
        });

        this.listClickCallbackBind = this.listClickCallback.bind(this);
        this.listMouseOverCallbackBind = this.listMouseOverCallback.bind(this);
    }

    reset() {

    }

    realTimeInputCheck() {
        if (this.sto) {
            clearTimeout(this.sto);
            this.sto = null;
        }

        const inputValue = this.input?.value;
        const inputTxt = inputValue?.trim();

        // 문자열이 있나?
        if (inputTxt) {
            // 바로 앞에서 api 호출한 문자열 인가?
            // 화살표 이동을 통해 입력된 문자열 인가?
            if (this.loadedKeyword !== inputTxt && this.dataBaseKeyword !== inputTxt && this.isValueFunctionText !== inputTxt) {
                this.load(inputTxt);
                this.isValueFunctionText = '';
            }
        } else {
            if (this.loadedKeyword != '') {
                setTimeout(() => {
                    if (this.input?.value?.trim()) return;
                    this.loadedKeyword = '';
                }, 10);
            }
            if (this.resultUL?.hasChildNodes()) {
                setTimeout(() => {
                    this.resultUL.innerHTML = '';
                    this.suggestWrapToggle(false);
                }, 10);
            }
        }

        this.deleteBtnToggle(inputTxt);
        this.sto = setTimeout(() => this.realTimeInputCheck(), 10);
    }

    deleteBtnToggle(inputTxt = '') {
        if (!this.option.useDelbtn) return false;

        if (inputTxt) {
            if (!this.deleteBtnIsShow) {
                if (this.deleteBtn) {
                    this.deleteBtn.style.display = 'block';
                }
                this.deleteBtnIsShow = true;
            }
        } else {
            if (this.deleteBtnIsShow) {
                if (this.deleteBtn) {
                    this.deleteBtn.style.display = 'none';
                }
                this.deleteBtnIsShow = false;
            }
        }
    }

    drawList(_data) {
        if (!this.input?.value?.trim()) return; // 인풋에 문자열 없으면 데이터가 들어와도 보여주지 않는다.

        let resultList = _data;
        resultList = this.option.responseListName1 ? resultList[`${this.option.responseListName1}`] : resultList['front']
        resultList = this.option.responseListName2 ? resultList[`${this.option.responseListName2}`] : resultList;

        this.suggestWrapToggle(resultList.length > 0);
        this.listRemoveEvent();

        let list = '';
        if (resultList.length) {
            let reg = new RegExp(this.loadedKeyword, 'i');
            list = resultList.map((item, idx) => {
                const regStr = reg.exec(item.keyword);
                const str = item.keyword.replace(regStr, `<mark>${regStr}</mark>`);
                return `<li data-idx="${idx}" data-keyword="${item.keyword}">${str}</li>`;
            }).join('');
        }
        if (this.resultUL) {
            this.resultUL.innerHTML = list;
        }
        this.listAddEvent();
    }

    listRemoveEvent() {
        this.parent?.querySelectorAll("[data-name='suggest_scroll'] ul li")?.forEach(li => {
            li?.removeEventListener('click', this.listClickCallbackBind);
            li?.removeEventListener('mouseover', this.listMouseOverCallbackBind);
        });
    }

    listAddEvent() {
        this.parent?.querySelectorAll("[data-name='suggest_scroll'] ul li")?.forEach(li => {
            li?.addEventListener('click', this.listClickCallbackBind);
            li?.addEventListener('mouseover', this.listMouseOverCallbackBind);
        });
    }

    listClickCallback(e) {
        const keyword = e?.currentTarget?.dataset?.keyword || '';

        this.setInputValue(keyword);
        this.submitGo();
    }

    listMouseOverCallback(e) {
        const target = e.currentTarget;
        const parent = target?.parentElement;
        const prevFocus = parent?.querySelector("li.focus");
        
        prevFocus?.classList?.remove('focus');
        target?.classList?.add('focus');
    }

    focusChange(_direction = 1) {
        const resultLi = this.resultUL?.querySelectorAll('li');
        const resultLiLength = resultLi.length;
        const oldFocusEl = this.resultUL?.querySelector('.focus');
        let focusIndex = this.getIndex(oldFocusEl) + (_direction === 1 ? 1 : -1);
        let newFocusEl;

        focusIndex = focusIndex < 0 ? resultLiLength : (focusIndex > resultLiLength ? 0 : focusIndex);
        newFocusEl = resultLi[focusIndex];

        oldFocusEl?.classList?.remove('focus');
        this.suggestWrapToggle(!!newFocusEl);

        if (newFocusEl) {
            newFocusEl?.focus();
            newFocusEl?.classList?.add('focus');
            this.dataBaseKeyword = newFocusEl?.dataset?.keyword;
            this.setInputValue(this.dataBaseKeyword);
        }
    }

    submitGo() {
        const inputVal = this.input?.value?.trim();
        this.suggestWrapToggle(false);
        if (typeof this.option.submitCallback === 'function' && inputVal !== '') {
            this.option.submitCallback(inputVal);
        }
    }

    suggestWrapToggle(_isShow = true) {
        this.setDisplay(this.suggestWrap, _isShow);
        if (!_isShow) {
            this.resultUL?.querySelectorAll('li')?.forEach(li => li?.classList?.remove('focus'));
        }
    }

    // public ---------------------------------------------------------------------
    changeAddParam(_param) {
        this.option.addParam = _param;
    }

    value(_txt) {
        this.isValueFunctionText = _txt;
        this.setInputValue(_txt);
    }

}

window.AutoSuggest = App;

export default App;